import SimpleTable from './Table';
import * as hooks from "./hooks";

/**
 * @namespace SimpleTable
 */

/**
 * 兼容旧版本创建表格方法
 * @param {string} mainCode 表格主区域编码
 * @param {object} config 表格业务配置
 */

export default function SimpleTableOutput() {
    this.register("table"); // 生成 this.cardTableDataSource[id]
    return {
        ...Object.entries(hooks).reduce((wrappedHooks, [name, hook]) => {
            wrappedHooks[name] = (...rest) => {
                console.log('SimpleTable调用：', name, '参数为：', ...rest);
                try {
                    return hook.call(this, ...rest);
                } catch(e) {
                    console.error(e);
                }
            };
            return wrappedHooks;
        }, {}),
    };
}

SimpleTableOutput.component = SimpleTable;
SimpleTableOutput.displayName = "SimpleTable";
SimpleTableOutput.unfinished = ["simpleTableUnFinishedApi"];
